"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconUnderwritingFilled = function IconUnderwritingFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return _react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, _react.default.createElement("title", null, "Underwriting"), _react.default.createElement("path", {
    d: "M33.5 10H7.5C7.36739 10 7.24021 10.0527 7.14645 10.1464C7.05268 10.2402 7 10.3674 7 10.5V28.5C7 28.6326 7.05268 28.7598 7.14645 28.8536C7.24021 28.9473 7.36739 29 7.5 29H11L13.4 34.61C13.4494 34.7285 13.5327 34.8297 13.6394 34.9008C13.7462 34.972 13.8717 35.01 14 35.01C14.1283 35.01 14.2538 34.972 14.3606 34.9008C14.4673 34.8297 14.5506 34.7285 14.6 34.61L17 29H33.5C33.6326 29 33.7598 28.9473 33.8536 28.8536C33.9473 28.7598 34 28.6326 34 28.5V10.5C34 10.3674 33.9473 10.2402 33.8536 10.1464C33.7598 10.0527 33.6326 10 33.5 10Z",
    fill: color
  }), _react.default.createElement("path", {
    d: "M43 25.5V37.5C43 37.6326 42.9473 37.7598 42.8535 37.8536C42.7598 37.9473 42.6326 38 42.5 38H40L38 42.67C37.9595 42.7693 37.8903 42.8544 37.8012 42.9142C37.7122 42.9741 37.6073 43.006 37.5 43.006C37.3927 43.006 37.2878 42.9741 37.1988 42.9142C37.1097 42.8544 37.0405 42.7693 37 42.67L35 38H22.34C22.2074 38 22.0802 37.9473 21.9864 37.8536C21.8927 37.7598 21.84 37.6326 21.84 37.5V31H33.5C34.163 31 34.7989 30.7366 35.2678 30.2678C35.7366 29.7989 36 29.163 36 28.5V25H42.5C42.6326 25 42.7598 25.0527 42.8535 25.1464C42.9473 25.2402 43 25.3674 43 25.5Z",
    fill: color
  }));
};

IconUnderwritingFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconUnderwritingFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconUnderwritingFilled;
exports.default = _default;